export default Object.freeze({
  None: 'none',
  Minute: 'minute',
  Hour: 'hour',
  Day: 'day',
  Month: 'month',
  BusinessDay: 'business-day',
});
